var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Text } from 'shared/components/ui';
import { Link as NavLink, useLocation } from 'react-router-dom';
import { TrackedClick } from 'shared/features/analytics';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: 0.2rem;\n  height: 100%;\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  :hover {\n    color: ", ";\n  }\n  border-bottom: ", ";\n"], ["\n  margin-right: 0.2rem;\n  height: 100%;\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  :hover {\n    color: ", ";\n  }\n  border-bottom: ", ";\n"])), function (_a) {
    var active = _a.active;
    return active ? 'var(--chakra-colors-green-500)' : 'var(--chakra-colors-gray-500)';
}, function (_a) {
    var active = _a.active;
    return (active ? 'var(--chakra-colors-green-100)' : '#FFFFFF');
}, '4px', function (_a) {
    var active = _a.active;
    return (active ? '' : '#000000');
}, function (_a) {
    var active = _a.active;
    return active && '4px solid var(--chakra-colors-green-500)';
});
var SubNavTab = function (_a) {
    var text = _a.text, url = _a.url, _b = _a.isActive, isActive = _b === void 0 ? false : _b;
    var location = useLocation();
    var pathname = location.pathname;
    var active = pathname === url || isActive;
    return (_jsx(_Fragment, { children: _jsx(Wrapper, __assign({ active: active, "data-testid": text }, { children: _jsx(TrackedClick, __assign({ eventName: "Subnav Tab", eventProperties: {
                    spring_doc_id: 'compass015',
                } }, { children: _jsx(NavLink, __assign({ to: url }, { children: _jsx(Text, __assign({ fontSize: "lg", fontWeight: 600, pl: 3, pr: 3, pt: 2, pb: 2, h: 3, textAlign: 'center' }, { children: text })) })) })) })) }));
};
export { SubNavTab };
var templateObject_1;
